import App from './SDOFSolverApp';
import { bootstrapReactApp } from '../shared';

bootstrapReactApp('iSDOFSolver', <App />);
